import { v4 as uuidv4 } from 'uuid';
const ATC_ID = 'ATC_ID';
const addAtcId = () => ctx => {
  let atcId = ctx.data.ATC_ID || ctx.cookies.get(ATC_ID);

  // If this middleware hasn't run and the ATC_ID cookie didn't exist, then generate a new value and set it in a
  // cookie and set atcId so that we will store the value in ctx
  if (!atcId) {
    atcId = uuidv4();
    const cookieSettings = [ATC_ID, atcId, {
      path: '/',
      // 4 years in milliseconds
      maxAge: (4 * 365 + 1) * 24 * 60 * 60 * 1000
    }];
    ctx.cookies.set(...cookieSettings);
  }
  ctx.data[ATC_ID] = atcId;
};
export default addAtcId;